import * as React from 'react';
import { CloseIcon } from './CloseIcon';
import * as styles from './HomeownerTooltip.css';

type Props = {
  isOpen: boolean;
  close(): void;
};

export class HomeownerTooltip extends React.Component<Props> {
  public render() {
    const { isOpen, close } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['text']}>
          Тип аккаунта «Cобственник» можно выбрать только если вы владелец
          объекта. В остальных случаях выбирайте тип «Агент». За нарушение этого
          правила аккаунт может быть заблокирован
        </div>
        <div onClick={close} className={styles['close-icon']}><CloseIcon /></div>
      </div>
    );
  }
}
